export default __webpack_public_path__ + "static/media/Indexx.aiUpdatedLogo.1ac0f5ba.svg";